import * as notifications from './notificationActions';

export function dispatchPayloadAction(asyncAction, success, failure) {
  return dispatch => {
    return dispatch({
      payload: asyncAction()
        .done(response => {
          success(dispatch, response);
        })
        .catch((error, textStatus) => {
          dispatch(notifications.showFailure(error));
          console.error(textStatus);
          if (failure) {
            failure(dispatch, error);
          }
        }),
    });
  };
}
